import script from "./SourceInputWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceInputWidget.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__